<template>
  <v-app>
    <div class="splash">
      <div class="splash-content">
        <img src="@/assets/logo.png" class="splash-image" alt="logo" />
        <div>
          <v-progress-linear indeterminate color="primary"> </v-progress-linear>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.splash {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  &-image {
    width: 150px;
    height: auto;
  }
}
</style>
